import { Component, EventEmitter, OnDestroy, OnInit, Output, viewChild, inject } from '@angular/core';
import { ClarityModule, ClrDatagrid } from '@clr/angular';
import { BehaviorSubject, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { APIService } from 'src/app/services/APIService/api.service';
import { OverlayService } from 'src/app/services/Overlay/overlay.service';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';
import { BasicStoreService } from 'src/app/services/BasicStore/basic-store.service';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/services/Auth/auth.service';

interface Summen {
  kosten: number;
  plankosten: number;
  personalstunden: number;
  personalstundenPlanung: number;
  typKosten: {
    PERSONAL: number;
    MATERIAL: number;
    MASCHINE: number;
    FREMDLEISTUNG: number;
  };
  typPlankosten: {
    PERSONAL: number;
    MATERIAL: number;
    MASCHINE: number;
    FREMDLEISTUNG: number;
  };
}

@Component({
  selector: 'app-kostenliste',
  templateUrl: './kostenliste.component.html',
  styleUrls: ['./kostenliste.component.scss'],
  imports: [CommonModule, ClarityModule, TablePrettyPrintPipe, HideIDColumnsPipe, MrTranslatePipe],
})
export class KostenListeComponent implements OnInit, OnDestroy {
  private readonly apiservice = inject(APIService);
  private readonly spinnerservice = inject(SpinnerService);
  private readonly overlayService = inject(OverlayService);
  private readonly basicStore = inject(BasicStoreService);

  // auftraege = new BehaviorSubject<any>({ columns: [], rows: null });
  auftraege: any = {
    rows: [],
    columns: [],
  };
  summen = new BehaviorSubject<Summen>({
    kosten: 0,
    plankosten: 0,
    personalstunden: 0,
    personalstundenPlanung: 0,
    typKosten: {
      PERSONAL: 0,
      MATERIAL: 0,
      MASCHINE: 0,
      FREMDLEISTUNG: 0,
    },
    typPlankosten: {
      PERSONAL: 0,
      MATERIAL: 0,
      MASCHINE: 0,
      FREMDLEISTUNG: 0,
    },
  });

  private readonly auftraegeDatagrid = viewChild<ClrDatagrid>('auftraegeDatagrid');

  pageSize = 20;

  @Output() dataRefresh = new EventEmitter();
  refreshSubscription: Subscription;
  componentStore: any;

  private window = window;
  ngOnInit(): void {
    this.window.onresize = _ => {
      this.resizeHeight();
    };
    this.spinnerservice.enable();
    this.componentStore = this.basicStore.getComponentStore('auftragsliste');

    if (!this.componentStore) {
      this.loadAuftraege();
    } else {
      setTimeout(() => {
        if (this.componentStore.auftraege) this.auftraege = this.componentStore.auftraege;
        if (this.componentStore.summen) this.summen.next(this.componentStore.summen);

        setTimeout(() => {
          this.resizeHeight();
          this.spinnerservice.disable();
        });
      });
    }
  }

  private loadAuftraege() {
    this.apiservice
      .getAuftraegeListe()
      .pipe(first())
      .subscribe((data: any) => {
        const { auftraege, summen } = data;
        if (auftraege?.rows?.length > 0) {
          if (this.auftraege.columns?.length == 0) {
            this.auftraege.columns = auftraege.columns;
          }
          this.auftraege.rows = auftraege.rows;
        }
        if (summen) this.summen.next(summen);

        setTimeout(() => {
          this.resizeHeight();
          this.spinnerservice.disable();
        });
      });
  }

  private resizeHeight() {
    let wrapperHeight =
      this.auftraegeDatagrid()?.datagridTable.nativeElement.parentElement.parentElement.offsetHeight - 15;
    if (wrapperHeight) this.pageSize = Math.floor(wrapperHeight / 26 - 1);
  }

  ngOnDestroy(): void {
    this.basicStore.setComponentStore('auftragsliste', {
      auftraege: this.auftraege,
      summen: this.summen.getValue(),
    });
    this.refreshSubscription?.unsubscribe();
    this.window.onresize = undefined;
  }

  openAuftrag(auftragRow) {
    if (this.refreshSubscription) this.refreshSubscription.unsubscribe();
    this.refreshSubscription = this.dataRefresh?.subscribe(val => {
      this.loadAuftraege();
    });
    this.overlayService.setOverlay({
      overlay: 'auftragDetail',
      data: {
        id: Number(auftragRow.AuftragNr),
        auftrag: auftragRow,
      },
      zIndex: 8,
      dataRefresh: this.dataRefresh,
    });
  }
}
